<div id="footer" class="pt-3 pb-3 mt-3">
  <div>
    <div class="footer-links">
      {{ 'ml_143928' | translate: { from_to_years: fromToYears } }}
    </div>
  </div>
</div>
